export default "__VITE_ASSET__DrXJ98j$__"